import { createSelector } from 'reselect';
import { MUST_DO, OTHER, CUSTOM, MONTH_TODO, WEEK_TODO } from '~/Config/Checklists';
import { allFonts } from '../Fonts';

import {
  HUMAN_DATE_FORMAT,
  HUMAN_DATE_TIME_FORMAT,
  HUMAN_TIME_FORMAT,
  HUMAN_TIME_FORMAT_24H,
  MEAL_PREPS,
  HUMAN_DATE_WITH_DAY_FORMAT,
} from './constants';

export const userOptions = state => state.UserOptions.data;
export const selectedFont = createSelector([allFonts, userOptions], (fonts, { font_id }) =>
  (fonts || []).find(({ id }) => id == font_id)
);
export const fontNameForEvents = createSelector(
  [selectedFont, userOptions],
  (selectedFont, userOptions) =>
    userOptions.use_font_for_events ? selectedFont?.css || 'Raleway' : 'Raleway'
);

const intlFormats = {
  [HUMAN_DATE_FORMAT]: 'DD/MM/YYYY',
  [HUMAN_DATE_TIME_FORMAT]: 'hh:mma on DD/MM/YYYY',
  [HUMAN_TIME_FORMAT]: HUMAN_TIME_FORMAT,
  [HUMAN_DATE_WITH_DAY_FORMAT]: 'ddd DD/MM/YYYY',
  'M/D/YYYY': 'D/M/YYYY',
  'h:mmp': 'h:mmp',
  'MMMM DD, Y': 'DD MMMM Y',
  'MMM D': 'D MMM',
};

const usFormats = {
  [HUMAN_DATE_FORMAT]: HUMAN_DATE_FORMAT,
  [HUMAN_DATE_TIME_FORMAT]: HUMAN_DATE_TIME_FORMAT,
  [HUMAN_TIME_FORMAT]: HUMAN_TIME_FORMAT,
  [HUMAN_DATE_WITH_DAY_FORMAT]: 'ddd M/DD/YYYY',
  'M/D/YYYY': 'M/D/YYYY',
  'h:mmp': 'h:mmp',
  'MMMM DD, Y': 'MMMM DD, Y',
  'MMM D': 'MMM D',
};

export const humanDateFormats = createSelector([userOptions], options => {
  return options?.use_intl_dates ? intlFormats : usFormats;
});

export const humanTimeFormats = createSelector([userOptions], ({ use_intl_time }) =>
  use_intl_time
    ? {
        [HUMAN_TIME_FORMAT]: HUMAN_TIME_FORMAT_24H,
        'h:mmp': HUMAN_TIME_FORMAT_24H,
        'h:mma': HUMAN_TIME_FORMAT_24H,
      }
    : {
        [HUMAN_TIME_FORMAT]: HUMAN_TIME_FORMAT,
        'h:mmp': 'h:mmp',
        'h:mma': 'h:mma',
      }
);

export const titlesForSections = createSelector(
  [userOptions],
  ({
    custom_list_title,
    priority_tasks_title,
    other_tasks_title,
    monthly_tasks_title,
    weekly_tasks_title,
    meals_title,
  }) => ({
    [MUST_DO]: priority_tasks_title,
    [OTHER]: other_tasks_title,
    [CUSTOM]: custom_list_title,
    [MONTH_TODO]: monthly_tasks_title,
    [WEEK_TODO]: weekly_tasks_title,
    [MEAL_PREPS]: meals_title,
  })
);
